import { Component, Input, OnInit } from '@angular/core';
import { NavController, NavParams, PopoverController } from 'ionic-angular';
import { PrizeGameProvider } from '../../providers/prize-game/prize-game';

/**
 * Generated class for the PrizeGameWallComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'prize-game-wall',
  templateUrl: 'prize-game-wall.html'
})
export class PrizeGameWallComponent implements OnInit {

  @Input() event: any;
  @Input() pin: any;
  @Input() admin: boolean;
  gameList: any[] = [];
  gameListUnpublished: any[] = [];

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public popoverCtrl: PopoverController,
    public prizeGame: PrizeGameProvider,
  ) {
    
    
  }

  ngOnInit() {
    console.log('EVENT!!! ', this.event)
    this.getGames();
  }

  openWinnerPage(gameId) {
    this.navCtrl.push('PrizeGameWinnerPage', {
      event: this.event.uuid,
      id: gameId,
    });
  }

  getGames() {
    this.prizeGame.getGameList(this.event.uuid).subscribe(gameListResponse => {
      console.log(gameListResponse);
      gameListResponse.forEach((element, index) => {
        if (element.published) {
          this.gameList.push(element);
        } else {
          this.gameListUnpublished.push(element);
        }
      });
    });
  }

  presentPopover(event, gameId, prizeCount) {
    let popover = this.popoverCtrl.create('PrizeGamePopoverPage', {
      eventId: this.event.uuid,
      gameId: gameId,
      prizeCount: prizeCount,
    });
    popover.present({
      ev: event
    });
    // popover.present({
    //   ev: myEvent,
    // });
  }

}



// WEBPACK FOOTER //
// ./src/components/prize-game-wall/prize-game-wall.ts